import React from 'react'

import { Page } from 'common'
import { ErrorHandler, Header, SignalFeedback } from 'components'
import { Routes } from 'common/constants'

import { usePrivacyPolicy } from '../hooks/usePrivacyPolicy'
import { PrivacyPolicyView } from './PrivacyPolicyView'
import { PrivacyPolicyMenuSkeleton } from './PrivacyPolicySkeleton'

export function PrivacyPolicy() {
  const {
    errorOrInactive,
    termSections,
    traceDetails,
    title,
    isContentLoading,
    isTermsPending,
    emptyPage,
    notFoundTerms,
    from,
  } = usePrivacyPolicy()

  if (isContentLoading || isTermsPending) return <PrivacyPolicyMenuSkeleton title={title} />

  if (errorOrInactive) {
    return <ErrorHandler traceDetails={traceDetails} componentName={PrivacyPolicy.name} />
  }

  return (
    <Page>
      <Header title={title} goToPath={from ? undefined : Routes.HOME} />
      {notFoundTerms && emptyPage ? (
        <SignalFeedback
          icon={emptyPage.icon}
          title={emptyPage.title}
          details={emptyPage.subtitle}
          type={emptyPage.type}
        />
      ) : (
        <PrivacyPolicyView termSections={termSections} />
      )}
    </Page>
  )
}
